import React from 'react'

import { Modal } from 'antd'

import AlertIcon from '../assets/images/ico_erro.svg'
import { getMessage } from './IntlMessages'
const { confirm } = Modal

export const showConfirmDialog = (onConfirm = () => ({})) => {
  confirm({
    icon: (
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <img src={AlertIcon} alt="" />
      </div>
    ),
    content: (
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <span>{getMessage('SureToDelete?')}</span>
      </div>
    ),
    cancelButtonProps: {
      style: {
        width: 148,
        borderColor: '#EE778F',
        color: '#EE778F'
      },
      type: 'ghost'
    },
    okButtonProps: {
      className: 'button-action',
      type: 'primary'
    },
    okText: getMessage('label.yes'),
    cancelText: getMessage('label.no'),
    onOk() {
      onConfirm()
    },
    onCancel() {}
  })
}
